import { isAcquisitionsChannel } from 'components/underwrite/postAcquisition/import/importTasks/taxonomyHelpers';

export const columnSchema = [
  { width: 80, field: 'assetId', displayName: 'Asset ID', type: 'number', fixed: true, required: true },
  { width: 98, field: 'asgPropID', displayName: 'PM ID', type: 'number', fixed: true, required: true },
  { width: 240, field: 'street', displayName: 'Street', type: 'string', required: true },
  { width: 130, field: 'city', displayName: 'City', type: 'string', required: true },
  { width: 70, field: 'state', displayName: 'State', type: 'string', required: true },
  { width: 91, field: 'zipCode', displayName: 'Zip Code', type: 'string', required: true },
  { width: 70, field: 'beds', displayName: 'Beds', type: 'number', format: { type: 'fixedPoint', precision: 0 }, required: true },
  { width: 72, field: 'baths', displayName: 'Baths', type: 'number', format: { type: 'fixedPoint', precision: 1 }, required: true },
  { width: 94, field: 'yearBuilt', displayName: 'Year Built', type: 'number', required: true },
  { width: 91, field: 'sqft', displayName: 'Square Feet', type: 'number', format: { type: 'fixedPoint', precision: 0 }, required: true },
  { width: 93, field: 'lotSize', displayName: 'Lot Size Sq Ft', format: { type: 'fixedPoint', precision: 0 }, type: 'number' },
  { width: 121, field: 'propertyType', displayName: 'Property Type', type: 'string', acceptedValues: [ 'Single Family', 'Townhome','Condo', 'Duplex', 'Triplex', 'Lot' ], required: true },
  { width: 90, field: 'latitude', displayName: 'Latitude', type: 'number', format: { type: 'fixedPoint', precision: 5 }, required: true },
  { width: 90, field: 'longitude', displayName: 'Longitude', type: 'number', format: { type: 'fixedPoint', precision: 5 }, required: true },
  { width: 90, field: 'region', displayName: 'Amherst Region', type: 'string' },
  { width: 600, field: 'notes', displayName: 'Notes', type: 'string' }
];

// Channel-aware view of the schema. The address-only Acquisitions channel has no Asset ID,
// so that column is hidden and not required (PM ID is resolved from the address instead).
// Before a channel is selected, no columns are shown (matches the Acquisitions Opportunity import,
// whose grid is empty behind the initial channel-select modal).
export const getColumnSchema = (entries, channel) => {
  if (!channel) return [];
  if (!isAcquisitionsChannel(entries, channel)) return columnSchema;
  return columnSchema.map(col =>
    col.field === 'assetId' ? { ...col, required: false, visible: false } : col
  );
};
